<template>
  <div>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
        <b-container fluid class="d-flex align-items-center">
          <b-row >
            <b-col lg="7" md="10">
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Crear modelo</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> El modelo se creo existosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del modelo</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre de modelo"
                      placeholder="Nombre"
                      v-model="nameModel"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Tipo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="type"
                      :options="optionsModels"
                      placeholder='Selecciona el tipo de artículo'
                      name="Tipo"
                      label="name"
                      track-by="id"
                      value-prop="id"
                      required
                      >
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row >
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Género</label>
                    <multiselect
                      :show-labels="false"
                      v-model="gender"
                      :options="genders"
                      :multiple="false"
                      placeholder='Selecciona el género del modelo'
                      label="name"
                      track-by="id"
                      value-prop="id"
                      name="Género"
                      required>
                    </multiselect>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Marca</label>
                    <multiselect
                      :show-labels="false"
                      v-model="brand"
                      :options="brands"
                      :multiple="false"
                      placeholder='Selecciona la marca'
                      label="name"
                      track-by="id"
                      value-prop="id"
                      name="Marca"
                      required>
                    </multiselect>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Hospitales</label>
                    <multiselect
                      :show-labels="false"
                      v-model="hospitalList"
                      :options="hospitals"
                      :multiple="true"
                      placeholder='Selecciona el hospital a asignar'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <!-- <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Areas</label>
                    <multiselect
                      :show-labels="false"
                      v-model="areaList"
                      :options="areas"
                      :multiple="true"
                      placeholder='Selecciona el area a asignar'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col> -->
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Colores disponibles</label>
                    <multiselect
                      :show-labels="false"
                      v-model="colorsList"
                      :options="colors"
                      :multiple="true"
                      placeholder='Selecciona los colores disponibles'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Colores bordado</label>
                    <multiselect
                      :show-labels="false"
                      v-model="threadColorList"
                      :options="threadColor"
                      :multiple="true"
                      placeholder='Selecciona los colores disponibles'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Tallas disponibles</label>
                    <multiselect
                      :show-labels="false"
                      v-model="sizesList"
                      :options="sizes"
                      :multiple="true"
                      placeholder='Selecciona las tallas disponibles'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Precio"
                      placeholder="00.0"
                      v-model="priceModel"
                      name="Precio"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Precio Tallas Extras"
                      placeholder="00.0"
                      v-model="priceExtrasModel"
                      name="Precio"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Descuento"
                      placeholder="00.0"
                      v-model="discount"
                      name="Descuento"
                    >
                    </base-input>
                  </b-col>

                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Conjunto Asociado (Pantalón)</label>
                    <multiselect
                      :show-labels="false"
                      v-model="modelAd"
                      :options="models"
                      :multiple="false"
                      placeholder='Selecciona el elemento asociado del conjunto'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Crear modelo</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      nameModel: '',
      style: '',
      type: '',
      priceModel: '',
      priceExtrasModel: '',
      discount: '',
      sequence: '',
      hospitalList: '',
      areaList: '',
      token: '',
      user: '',
      hospitals: [],
      areas: [],
      colorsList: '',
      colors: [],
      threadColorList: '',
      threadColor: [],
      sizesList: '',
      sizes: [],
      brands: [],
      models: [],
      modelAd: '',
      genders: [
        {
          "id": "3",
          "name": "Unisex"
        },
        {
          "id": "4",
          "name": "Caballero"
        },
        {
          "id": "5",
          "name": "Dama"
        },],
      success: '',
      error: '',
      brand: '',
      gender: '',
      optionsModels: []
    }
  },
  methods: {
    updateProfile() {
        let formData = new FormData()
        formData.append('user_id', this.user)
        formData.append('api_token', this.token)
        formData.append('option','create_model')
        formData.append('m_name', this.nameModel)
        formData.append('m_brand', this.brand.id)
        formData.append('m_type', this.type.id)
        formData.append('m_gender', this.gender.id)
        formData.append('m_price', this.priceModel)
        formData.append('m_price_extra', this.priceExtrasModel)
        formData.append('m_discount', this.discount)
        if(this.modelAd)
          formData.append('m_associated_model', this.modelAd.id)
        if(this.hospitalList)
          formData.append('h_list', this.hospitalList ? this.hospitalList.map((elem) => elem.id).toString() : '')
        if(this.colorsList)
          formData.append('c_list', this.colorsList ? this.colorsList.map((elem) => elem.id).toString() : '')
        if(this.threadColorList)
          formData.append('c_threads', this.threadColorList ? this.threadColorList.map((elem) => elem.id).toString() : '')
        if(this.sizesList)
          formData.append('s_list', this.sizesList ? this.sizesList.map((elem) => elem.id).toString() : '')


        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (!response.data.error.code) {
            this.success = true
            // this.nameModel = ''
            // this.type = ''
            // this.hospitalList = []
            // this.brands = []
            // this.colorsList = []
          } else {
            this.success = false
            this.error = response.data.error.description
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
    )
    .then((response) => {
      if (!response.data.error.code && response.data.hospitals) {
        let temp = [], tempColor = [], tempModels = [], tempBrand = [], tempType = [], tempArea = [], tempSize = [], tempThreads = []
        Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
            temp.push(value[0])
        })
        this.hospitals = temp

        Object.keys(response.data.threadcolors).map((key) => [response.data.threadcolors[key]]).map(function(value) {
          tempThreads.push(value[0])
        })
        this.threadColor = tempThreads

        Object.keys(response.data.colors).map((key) => [response.data.colors[key]]).map(function(value) {
          tempColor.push(value[0])
        })
        this.colors = tempColor

        Object.keys(response.data.brands).map((key) => [response.data.brands[key]]).map(function(value) {
            tempBrand.push(value[0])
          })
        this.brands = tempBrand


        Object.keys(response.data.types).map((key) => [response.data.types[key]]).map(function(value) {
          tempType.push(value[0])
          })
        this.optionsModels = tempType

        Object.keys(response.data.areas).map((key) => [response.data.areas[key]]).map(function(value) {
              tempArea.push(value[0])
          })
        this.areas = tempArea

        Object.keys(response.data.sizes).map((key) => [response.data.sizes[key]]).map(function(value) {
              tempSize.push(value[0])
          })
        this.sizes = tempSize

        Object.keys(response.data.models).map((key) => [response.data.models[key]]).map(function(value) {
            tempModels.push(value[0])
          })
        this.models = tempModels
      }
    })
    .catch((err) => {
      console.log(err)
    })
  }
};
</script>
<style></style>
